import React from "react";

// --- ASSETS --- //
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

// --- CSS --- //
import "../../styles/footer-public.css";

const Footer_Public = () => {
    return (
        <>
            {/* FOOTER */}
            <footer className="footer">
                <div className="footer-top">
                    <div className="footer-info">
                        <div className="info-item"><a href="https://www.google.com/maps/place/361+S+Camino+Del+Rio,+Durango,+CO+81303/"><PlaceIcon/><p>361 S. Camino del Rio #45<br></br>Durango, CO 81303</p></a></div>
                        <div className="info-item"><a href="tel:9705015156"><PhoneIcon/><p>(970) 501-5156</p></a></div>
                        <div className="info-item"><a href="mailto:info@vertcertapp.com"><EmailIcon/><p>info@vertcertapp.com</p></a></div>
                    </div>
                    <div className="footer-social">
                        <a href="https://www.instagram.com/vertcertapp/" aria-label="Instagram"><InstagramIcon /></a>
                    </div>
                    <div className="footer-contact">
                        <h3>Have More Questions?</h3>
                        <a href="/contact"><button>Contact Us</button></a>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>© {new Date().getFullYear()} VERT CERT LLC. All Rights Reserved.</p>
                    <a href="/terms">Terms of Service</a>
                    <a href="/privacy">Privacy Policy</a>
                    <p style={{fontSize: "9pt"}}>Our Terms of Service and Privacy Policy are currently in development. By continuing to use our website, you acknowledge and accept all associated risks.</p>
                </div>
            </footer>
        </>
    );
};

export default Footer_Public;